import { ReactComponent as Rectangle } from './svg/Rectangle.svg'
import { ReactComponent as Circle } from './svg/Circle.svg'
import { ReactComponent as Triangle } from './svg/Triangle.svg'
import { ReactComponent as RoundedSquare } from './svg/RoundedSquare.svg'
import { ReactComponent as Diamond } from './svg/Diamond.svg'
import { ReactComponent as Pentagon } from './svg/Pentagon.svg'
import { ReactComponent as Hexagon } from './svg/Hexagon.svg'
import { ReactComponent as Octagon } from './svg/Octagon.svg'
import { ReactComponent as Parallelogram } from './svg/Parallelogram.svg'
import { ReactComponent as Trapezoid } from './svg/Trapezoid.svg'
import { ReactComponent as HalfCircle } from './svg/HalfCircle.svg'
import { ReactComponent as Pill } from './svg/Pill.svg'
import { ReactComponent as FourPointStar } from './svg/FourPointStar.svg'
import { ReactComponent as FivePointStarAlt } from './svg/FivePointStarAlt.svg'
import { ReactComponent as FivePointStar } from './svg/FivePointStar.svg'
import { ReactComponent as SixPointStar } from './svg/SixPointStar.svg'
import { ReactComponent as EightPointStar } from './svg/EightPointStar.svg'
import { ReactComponent as StarBurst } from './svg/StarBurst.svg'
import { ReactComponent as PromoCircle } from './svg/PromoCircle.svg'
import { ReactComponent as Plus } from './svg/Plus.svg'
import { ReactComponent as ArrowLeft } from './svg/ArrowLeft.svg'
import { ReactComponent as ArrowRight } from './svg/ArrowRight.svg'
import { ReactComponent as ArrowUp } from './svg/ArrowUp.svg'
import { ReactComponent as ArrowDown } from './svg/ArrowDown.svg'
import { ReactComponent as ArrowLeftRight } from './svg/ArrowLeftRight.svg'
import { ReactComponent as Crescent } from './svg/Crescent.svg'
import { ReactComponent as Splash } from './svg/Splash.svg'
import { ReactComponent as Heart } from './svg/Heart.svg'
import { ReactComponent as Drop } from './svg/Drop.svg'
import { ReactComponent as Cloud } from './svg/Cloud.svg'
import { ReactComponent as Bookmark } from './svg/Bookmark.svg'
import { ReactComponent as Pointer } from './svg/Pointer.svg'
import { ReactComponent as Ticket } from './svg/Ticket.svg'
import { ReactComponent } from 'react-hotkeys'
import { MaskShapeProps } from 'components/VisualStudioPlayground/Shapes/MaskShape/Types'
import { GeoShapeProps } from 'components/VisualStudioPlayground/Shapes/GeoShape/Types'
import { framesSvgDefs } from './framesSvgDefs'

import * as Masks from './masks'

export const geoShapes: Array<{
  geo: GeoShapeProps['geo']
  label: string
  props?: Partial<GeoShapeProps>
  component: ReactComponent
}> = [
  { geo: 'circle', label: 'Circle', component: Circle },
  { geo: 'rectangle', label: 'Rectangle', component: Rectangle },
  { geo: 'rectangle', label: 'Rounded Rectangle', props: { cornerRounding: 10 }, component: RoundedSquare },
  { geo: 'triangle', label: 'Triangle', component: Triangle },
  { geo: 'diamond', label: 'Diamond', component: Diamond },
  { geo: 'pentagon', label: 'Pentagon', component: Pentagon },
  { geo: 'hexagon', label: 'Hexagon', component: Hexagon },
  { geo: 'octagon', label: 'Octagon', component: Octagon },
  { geo: 'parallelogram', label: 'Parallelogram', component: Parallelogram },
  { geo: 'trapezoid', label: 'Trapezoid', component: Trapezoid },
  { geo: 'halfCircle', label: 'Half Circle', component: HalfCircle },
  { geo: 'pill', label: 'Pill', component: Pill },
  { geo: 'fourPointStar', label: 'Four Point Star', component: FourPointStar },
  { geo: 'fivePointStarAlt', label: 'Five Point Star Alt', component: FivePointStarAlt },
  { geo: 'fivePointStar', label: 'Five Point Star', component: FivePointStar },
  { geo: 'sixPointStar', label: 'Six Point Star', component: SixPointStar },
  { geo: 'eightPointStar', label: 'Eight Point Star', component: EightPointStar },
  { geo: 'starBurst', label: 'Star Burst', component: StarBurst },
  { geo: 'promoCircle', label: 'Promo Circle', component: PromoCircle },
  { geo: 'plus', label: 'Plus', component: Plus },
  { geo: 'arrowLeft', label: 'Arrow Left', component: ArrowLeft },
  { geo: 'arrowRight', label: 'Arrow Right', component: ArrowRight },
  { geo: 'arrowUp', label: 'Arrow Up', component: ArrowUp },
  { geo: 'arrowDown', label: 'Arrow Down', component: ArrowDown },
  { geo: 'arrowLeftRight', label: 'Arrow Left Right', component: ArrowLeftRight },
  { geo: 'crescent', label: 'Crescent', component: Crescent },
  { geo: 'splash', label: 'Splash', component: Splash },
  { geo: 'heart', label: 'Heart', component: Heart },
  { geo: 'drop', label: 'Drop', component: Drop },
  { geo: 'cloud', label: 'Cloud', component: Cloud },
  { geo: 'bookmark', label: 'Bookmark', component: Bookmark },
  { geo: 'pointer', label: 'Pointer', component: Pointer },
  { geo: 'ticket', label: 'Ticket', component: Ticket },
]

export const maskShapes: Array<{
  label: string
  props: Partial<MaskShapeProps>
  component: ReactComponent
}> = [
  { label: 'Circle Frame', component: Masks.Circle, props: { svgDefs: framesSvgDefs.circle } },
  { label: 'Rectangle Frame', component: Masks.Rectangle, props: { svgDefs: framesSvgDefs.rectangle } },
  {
    label: 'Rounded Rectangle Frame',
    component: Masks.RoundedSquare,
    props: { svgDefs: framesSvgDefs.rectangle, cornerRounding: 10 },
  },
  { label: 'Triangle Frame', component: Masks.Triangle, props: { svgDefs: framesSvgDefs.triangle } },
  { label: 'Diamond Frame', component: Masks.Diamond, props: { svgDefs: framesSvgDefs.diamond } },
  { label: 'Pentagon Frame', component: Masks.Pentagon, props: { svgDefs: framesSvgDefs.pentagon } },
  { label: 'Hexagon Frame', component: Masks.Hexagon, props: { svgDefs: framesSvgDefs.hexagon } },
  { label: 'Octagon Frame', component: Masks.Octagon, props: { svgDefs: framesSvgDefs.octagon } },
  { label: 'Parallelogram Frame', component: Masks.Parallelogram, props: { svgDefs: framesSvgDefs.parallelogram } },
  { label: 'Trapezoid Frame', component: Masks.Trapezoid, props: { svgDefs: framesSvgDefs.trapezoid } },
  { label: 'Half Circle Frame', component: Masks.HalfCircle, props: { svgDefs: framesSvgDefs.halfCircle } },
  { label: 'Pill Frame', component: Masks.Pill, props: { svgDefs: framesSvgDefs.pill } },
  { label: 'Four Point Star Frame', component: Masks.FourPointStar, props: { svgDefs: framesSvgDefs.fourPointStar } },
  {
    label: 'Five Point Star Alt Frame',
    component: Masks.FivePointStarAlt,
    props: { svgDefs: framesSvgDefs.fivePointStarAlt },
  },
  { label: 'Five Point Star Frame', component: Masks.FivePointStar, props: { svgDefs: framesSvgDefs.fivePointStar } },
  { label: 'Six Point Star Frame', component: Masks.SixPointStar, props: { svgDefs: framesSvgDefs.sixPointStar } },
  {
    label: 'Eight Point Star Frame',
    component: Masks.EightPointStar,
    props: { svgDefs: framesSvgDefs.eightPointStar },
  },
  { label: 'Star Burst Frame', component: Masks.StarBurst, props: { svgDefs: framesSvgDefs.starBurst } },
  { label: 'Promo Circle Frame', component: Masks.PromoCircle, props: { svgDefs: framesSvgDefs.promoCircle } },
  { label: 'Plus Frame', component: Masks.Plus, props: { svgDefs: framesSvgDefs.plus } },
  { label: 'Arrow Left Frame', component: Masks.ArrowLeft, props: { svgDefs: framesSvgDefs.arrowLeft } },
  { label: 'Arrow Right Frame', component: Masks.ArrowRight, props: { svgDefs: framesSvgDefs.arrowRight } },
  { label: 'Arrow Up Frame', component: Masks.ArrowUp, props: { svgDefs: framesSvgDefs.arrowUp } },
  { label: 'Arrow Down Frame', component: Masks.ArrowDown, props: { svgDefs: framesSvgDefs.arrowDown } },
  {
    label: 'Arrow Left Right Frame',
    component: Masks.ArrowLeftRight,
    props: { svgDefs: framesSvgDefs.arrowLeftRight },
  },
  { label: 'Crescent Frame', component: Masks.Crescent, props: { svgDefs: framesSvgDefs.crescent } },
  { label: 'Splash Frame', component: Masks.Splash, props: { svgDefs: framesSvgDefs.splash } },
  { label: 'Heart Frame', component: Masks.Heart, props: { svgDefs: framesSvgDefs.heart } },
  { label: 'Drop Frame', component: Masks.Drop, props: { svgDefs: framesSvgDefs.drop } },
  { label: 'Cloud Frame', component: Masks.Cloud, props: { svgDefs: framesSvgDefs.cloud } },
  { label: 'Bookmark Frame', component: Masks.Bookmark, props: { svgDefs: framesSvgDefs.bookmark } },
  { label: 'Pointer Frame', component: Masks.Pointer, props: { svgDefs: framesSvgDefs.pointer } },
  { label: 'Ticket Frame', component: Masks.Ticket, props: { svgDefs: framesSvgDefs.ticket } },
]
